(function (factory) {
                    typeof define === 'function' && define.amd ? define('map', factory) :
                    factory();
})((function () { 'use strict';



}));
